module.exports = __webpack_public_path__ + "static/media/MainLandingPageHero1.75efad6c.jpg";